/**
 * @description Converts a percent betweenn 0 - 100 to hex string of length 2
 *
 * @example convertPercentToHex(50) // '80'
 * @param {number} percent
 * @return {string}  hex code
 */
export var convertPercentToHex = function (percent) {
    if (percent > 100)
        return 'ff';
    if (percent < 0)
        return '00';
    var hex = Math.round(Math.ceil((percent / 100) * 255)).toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
};
//# sourceMappingURL=convertPercentToHex.js.map